import React from "react";
interface ITitleProps {
  greenText?: string;
  yellowText?: string;
  underline?: boolean;
}

const Title = ({ greenText, yellowText, underline = true }: ITitleProps) => {
  return (
    <div className="flex flex-col items-center justify-center typography-h5-semibold text-center my-16">
      <div>
        <span className="text-primary-500">{greenText}</span>
        <span className="text-secondary-500">{yellowText}</span>
        {underline && (
          <div className="w-full mt-2 flex justify-center">
            <div className="relative w-36 h-2">
              <div className="absolute inset-0 bg-gray-200 rounded-lg" />
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-2 bg-[#8474A9] rounded-lg" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Title;
